export const minWTN = 40;
export const minConfidence = 0;
